import React from "react";
import { ReactComponent as Pencil } from "../assets/icons/pencil.svg";
import { ReactComponent as Trash } from "../assets/icons/trash.svg";
import { FaFilter } from "react-icons/fa";


const Status = ({ color, label }) => (
  <div
    className={`min-w-fit w-24 font-bold text-white text-center border-2 border-${color}`}
  >
    {label}
  </div>
);

export default function Card({
  avatar,
  title,
  spacing = "md",
  status = [],
  className = "",
  onEdit,
  onDelete,
  onFilter,
  children,
}) {
  if (!Array.isArray(status)) {
    status = [status];
  }
  return (
    <div
      className={"flex justify-items-stretch bg-active rounded-sm " + className}
    >
      {avatar ? <img className={`h-[100px] w-[100px]`} alt="avatar" src={avatar} /> : null}
      <div
        className={`${
          spacing === "md"
            ? "ml-5 mt-5"
            : spacing === "sm"
            ? "ml-2 mt-2"
            : "ml-8 mt-8"
        } grow`}
      >
        <div className="font-bold text-lg text-white">{title}</div>
        <div className="text-white font-sans">{children}</div>
      </div>
      <div
        className={`flex flex-col items-end ${
          spacing === "md"
            ? "mr-5 mt-5"
            : spacing === "sm"
            ? "mr-2 mt-2"
            : "mr-8 mt-8"
        }  justify-between`}
      >
        <div>
          {status.map((s, i) => (
            <Status key={"ks" + i} color={s.color} label={s.label} />
          ))}
        </div>
        <div className="flex gap-2 mb-2">
          {onFilter ? (
            <button onClick={onFilter}>
              <FaFilter icon="fa-solid fa-filter" className="w-6 h-6 fill-[#999]" />
            </button>
          ) : null}
          {onEdit ? (
            <button onClick={onEdit}>
              <Pencil className="w-6 h-6 fill-[#999]" />
            </button>
          ) : null}
          {onDelete ? (
            <button onClick={onDelete}>
              <Trash className="w-6 h-6 fill-[#999]" />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
